module.exports = __webpack_public_path__ + "11_mustache_grey.87438458.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/11_mustache_grey.png
// module id = NFtG
// module chunks = 0